import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, LogOut } from "lucide-react";

interface LogoutSectionProps {
  loading: boolean;
  onLogout: () => Promise<void>;
}

export function LogoutSection({ loading, onLogout }: LogoutSectionProps) {
  return (
    <Card 
      className="border-red-200 transition-all duration-300 hover:shadow-lg bg-white/50 backdrop-blur-sm"
      role="region"
      aria-label="Logg ut seksjon"
    >
      <CardHeader className="space-y-1">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-full bg-red-100">
            <LogOut className="h-5 w-5 text-red-600" />
          </div>
          <div>
            <CardTitle className="text-xl text-red-900">Logg ut</CardTitle>
            <CardDescription className="text-sm text-red-600/80">
              Logg ut av systemet
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <Button 
          variant="destructive"
          onClick={onLogout}
          disabled={loading}
          className="w-full sm:w-auto bg-red-600 hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          aria-label="Logg ut av systemet"
        >
          {loading ? (
            <Loader2 className="h-4 w-4 animate-spin mr-2" />
          ) : (
            <LogOut className="h-4 w-4 mr-2" />
          )}
          Logg ut
        </Button>
      </CardContent>
    </Card>
  );
}